module.exports = __webpack_public_path__ + "static/media/prix.74ec4af4.jpg";